import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.deliveries')
  .service('DeliveriesAPI', DeliveriesAPI);

function DeliveriesAPI(): BringozApi {
  return {
    base: `/services`,
    infiniteScroll: {
      address: `/services`,
      cmd: 'GET'
    },
    actions: {
      cancel: {
        address: 'actions/cancel',
        cmd: 'POST',
        updateable: true
      },
      auction: {
        address: 'actions/auction',
        cmd: 'POST',
        updateable: true
      },
      export: {
        address: 'actions/export',
        cmd: 'POST',
        updateable: false
      },
      reset: {
        address: 'actions/reset',
        cmd: 'POST',
        updateable: true
      },
      manualHandle: {
        address: 'actions/manualHandle/async',
        cmd: 'POST',
        updateable: false
      },
      getAssignAgentData: {
        address: 'actions/assign',
        cmd: 'GET',
        updateable: false
      },
      getAssignResourceAllocationData: {
        address: 'actions/routeResourceRecommendation',
        cmd: 'GET',
        updateable: false
      },
      addServicesToResource: {
        address: 'actions/addToResource',
        cmd: 'POST',
        updateable: false
      },
      assign: {
        address: 'actions/assign/{id}',
        cmd: 'POST',
        updateable: true
      },
      reassign: {
        address: 'actions/assignAbortedServices/{id}',
        cmd: 'POST',
        updateable: true
      },
      autoAssign: {
        address: 'actions/autoAssign',
        cmd: 'POST',
        updateable: true
      },
      reassignCanceledDropoff: {
        address: 'actions/autoAssignAbortedServices',
        cmd: 'POST',
        updateable: true
      },
      addNote: {
        address: 'actions/note',
        cmd: 'POST',
        updateable: true
      },
      backInStore: {
        address: 'actions/backInStore',
        cmd: 'POST',
        updateable: true
      },
      getLogsTimeline: {
        address: '{id}/timeline',
        cmd: 'GET',
        updateable: true
      },
      bulkSMS: {
        address: 'actions/sms',
        cmd: 'POST',
        updateable: true
      },
      bulkSMSTemplates: {
        address: 'actions/sms/templates',
        cmd: 'GET',
        updateable: false
      },
      updateCompletedService: {
        address: 'actions/{id}/finished',
        cmd: 'POST',
        updateable: true
      },
      getTotals: {
        address: 'totals/statuses',
        cmd: 'GET',
        updateable: false
      },
      getAnalysis: {
        address: 'analysis/analyze',
        cmd: 'POST',
        updateable: false
      },
      mergeAnalysis: {
        address: 'analysis/merge',
        cmd: 'POST',
        updateable: false
      },
      splitAnalysis: {
        address: 'analysis/split',
        cmd: 'POST',
        updateable: false
      },
      getAnalysisConfiguration: {
        address: 'analysis/configuration',
        cmd: 'GET',
        updateable: false
      },
      setAnalysisConfiguration: {
        address: 'analysis/configuration',
        cmd: 'POST',
        updateable: false
      },
      createRoutes: {
        address: 'analysis/generate',
        cmd: 'PUT',
        updateable: false
      },
      getRecurringServices: {
        address: 'recurring',
        cmd: 'GET',
        updateable: false
      },
      createRecurringServiceTemplate: {
        address: 'recurring/create',
        cmd: 'POST',
        updateable: false
      },
      createRecurringService: {
        address: 'recurring',
        cmd: 'POST',
        updateable: false
      },
      updateRecurringService: {
        address: 'recurring/{id}',
        cmd: 'PUT',
        updateable: false
      },
      deleteRecurringService: {
        address: 'recurring',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      updateBulk: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      getDeliveryBilling: {
        address: '{serviceId}/billing',
        cmd: 'GET',
        updateable: false,
      },
      globalSearch: {
        address: 'super/search',
        cmd: 'GET',
        updateable: true
      },
      updateServiceBilling: {
        address: '{serviceId}/billing',
        cmd: 'POST',
        updateable: false
      },
      updateServiceProNumber: {
        address: '{serviceId}/pro',
        cmd: 'POST',
        updateable: true
      },
      bulkUpdateLocation: {
        address: 'bulkUpdateTaskSpec',
        cmd: 'POST',
        updateable: true
      },
      bulkUpdateTaskSpec: {
        address: 'bulkEditLocation',
        cmd: 'POST',
        updateable: true
      },
      deleteNote: {
        address: '{serviceId}/note',
        cmd: 'DELETE',
        updateable: false
      },
      getExpenses: {
        address: '{serviceId}/expenses',
        cmd: 'GET',
        updateable: false
      },
      getEditOrderOptions: {
        address: 'edit/{serviceId}',
        cmd: 'GET',
        updateable: false
      },
      updateTaskLocation: {
        address: 'edit/{serviceId}/{taskId}/location',
        cmd: 'POST',
        updateable: true
      },
      updateReferenceIds: {
        address: 'edit/{serviceId}/referenceIds',
        cmd: 'POST',
        updateable: true
      },
      unlinkRelatedTask: {
        address: '{serviceId}/relation',
        cmd: 'DELETE',
        updateable: false
      },
      updateServiceMetaData: {
        address: '{serviceId}/metadata',
        cmd: 'PUT',
        updateable: false
      },
      updateServicesMetaData: {
        address: 'actions/bulk/metadata',
        cmd: 'PUT',
        updateable: false
      },
      updateMissingItems: {
        address: '{serviceId}/updateServiceMissingItems',
        cmd: 'POST',
        updateable: false
      },
      updateOperationalContacts: {
        address: '{serviceId}/operationalContacts',
        cmd: 'POST',
        updateable: true
      },
      movePackages: {
        address: '{serviceId}/movePackages',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}
